module.exports = __webpack_public_path__ + "img/friends-top.495a21cf.jpg";